import useAdminData from './useAdminData';
import { fetchTopTemplates, fetchTopQuickReplies } from '../../services/adminStatsService';

export default function AdminTemplates() {
  const templates = useAdminData(fetchTopTemplates, 'limit=30');
  const quickReplies = useAdminData(fetchTopQuickReplies, 'limit=30');

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="bg-white rounded-lg border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 px-4 py-3 border-b border-gray-200">
          Top templates
        </h3>
        {templates.loading ? <Loading /> : templates.error ? <Err msg={templates.error} /> : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
              <tr>
                <th className="px-3 py-2 text-left">Template</th>
                <th className="px-3 py-2 text-left">Market</th>
                <th className="px-3 py-2 text-right">Sent</th>
              </tr>
            </thead>
            <tbody>
              {(templates.data?.data || []).map((r, i) => (
                <tr key={`${r.templateName}-${r.market}-${i}`} className="border-t border-gray-100">
                  <td className="px-3 py-2 font-mono text-xs">{r.templateName}</td>
                  <td className="px-3 py-2">{r.market}</td>
                  <td className="px-3 py-2 text-right">{r.count.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="bg-white rounded-lg border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 px-4 py-3 border-b border-gray-200">
          Top quick replies
        </h3>
        {quickReplies.loading ? <Loading /> : quickReplies.error ? <Err msg={quickReplies.error} /> : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
              <tr>
                <th className="px-3 py-2 text-left">Shortcut</th>
                <th className="px-3 py-2 text-left">Title</th>
                <th className="px-3 py-2 text-left">User</th>
                <th className="px-3 py-2 text-right">Used</th>
              </tr>
            </thead>
            <tbody>
              {(quickReplies.data?.data || []).map((r) => (
                <tr key={r.id} className="border-t border-gray-100">
                  <td className="px-3 py-2 font-mono text-xs">/{r.shortcut}</td>
                  <td className="px-3 py-2">{r.title}</td>
                  <td className="px-3 py-2 text-gray-500">
                    {r.isGlobal ? <span className="italic">global</span> : r.userName || '—'}
                  </td>
                  <td className="px-3 py-2 text-right">{r.usageCount.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function Loading() {
  return <div className="text-gray-500 text-sm p-4">Loading…</div>;
}
function Err({ msg }) {
  return <div className="text-red-600 text-sm p-4">{msg}</div>;
}
